import type { RouteObject } from 'react-router';
import { StoreDetailPage } from './StoreDetailPage';
import { StoreListPage } from './StoreListPage';

/** Routes for the stores area (store list, detail, household prefs). Mounted inside RequireHousehold. */
export const storesRoutes: RouteObject[] = [
  { path: '/stores', element: <StoreListPage /> },
  { path: '/stores/:id', element: <StoreDetailPage /> },
];
